import React, { useState, Fragment, useEffect } from "react";
import DataTable from "react-data-table-component";
import { Link, useNavigate } from "react-router-dom";
import { FaEdit } from "react-icons/fa";
import { Form } from "react-bootstrap";
import { getSocialLinkAxios, sicialHideShowAxios } from "../../Actions/axios";
import config from "../../config/config";
import { isEmpty } from "../../Actions/common";
import { toast } from "react-toastify";

const SocialList = () => {
  const navigate = useNavigate();
  const [socialList, setSocialList] = useState([]);

  const getSocialList = async () => {
    let resp = await getSocialLinkAxios({
      page: 0,
      limit: Number.MAX_SAFE_INTEGER,
    });
    console.log("🚀 ~ getSocialList ~ resp:", resp);
    if (resp?.status) {
      setSocialList(resp?.data);
    }
  };

  const socialhideshow = async (id, isAll) => {
    let resp = await sicialHideShowAxios({
      ...(!isEmpty(id) ? { _id: id } : { all: isAll }),
    });
    console.log("🚀 ~ socialhideshow ~ resp:", resp);
    if (resp?.status) {
      toast.success(resp?.message);
      getSocialList();
    } else {
      toast.error(resp?.message);
    }
  };


  const columns = [
    {
      name: "S.no",
      align: "left",
      sortable: false,
      selector: (row,i) => <p>{i+1}</p>,  
    },
    {
      name: "Title",
      align: "left",
      sortable: false,
      selector: (row) => row.title,
    },
    {
        name: "Link",
        align: "left",
        sortable: false,
        selector: (row) => row.link,
      },
    {
      name: "LOGO",
      align: "left",
      sortable: false,
      selector: (row) => (
        <>
          <img
            src={`${config.Back_URL}social/${row.logo}`}
            style={{ width: "20px", marginRight: "5px" }}
            alt={row.title}
          />
        </>
      ),
    },
    {
      name: "isHide",
      align: "left",
      sortable: false,
      selector: (row) => (
        <>
          <button
            className={`btn sitebtn btn-sm ${row._id}`}
            onClick={() => socialhideshow(row?._id)}
          >
            {row.ishide ? "Show" : "Hide"}
          </button>
        </>
      ),
    },
    {
      name: "Action",
      align: "left",
      sortable: false,
      cell: (record) => {
        return (
          <Fragment>
            <button
              className={`btn sitebtn btn-sm ${record._id}`}
              onClick={() => navigate("/socialedit", { state: { ...record } })}
            >
              <FaEdit />
            </button>
          </Fragment>
        );
      },
    },
  ];

  useEffect(() => {
    getSocialList();
  }, []);

  return (
    <div className="cmslist">
      <h1 className="pagehead">Social List</h1>
      <div className="cardbox">
        <div className="d-flex align-items-center justify-content-end gap-3 mb-4">
          <Link to="/socialadd" className="btn sitebtn">
            Add
          </Link>
        </div>
        <div className="tablebox">
          <DataTable
            className="react-datatables"
            columns={columns}
            data={socialList}
            pagination 
            paginationRowsPerPageOptions={[5, 10, 15, 20]}
          />
        </div>
      </div>
    </div>
  );
};

export default SocialList;
